var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 880.182,
    height: 664.736,
    viewBox: "0 0 880.182 664.736",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(-551 -324.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782-2608",
    "data-name": "Path 782",
    d: "M15.18,488.859a1.7,1.7,0,0,0,1.734,1.669H881.621a1.67,1.67,0,1,0,0-3.337H16.914A1.7,1.7,0,0,0,15.18,488.859Z",
    transform: "translate(547.826 489.929)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783-2609",
    "data-name": "Path 783",
    d: "M360.492,370.945a29.205,29.205,0,0,1-57.628,0H229.146V530.7H434.209V370.945H360.492Z",
    transform: "translate(643.158 443.177)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 20.268,
    height: 3.577,
    transform: "translate(875.882 973.285)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 20.268,
    height: 3.577,
    transform: "translate(1055.311 973.88)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 205.064,
    height: 5.561,
    transform: "translate(872.902 961.224)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784-2610",
    "data-name": "Path 784",
    d: "M836.241,515.493H11.432A11.445,11.445,0,0,1,0,504.061V33.344A11.445,11.445,0,0,1,11.432,21.911H836.241a11.445,11.445,0,0,1,11.432,11.432V504.061a11.446,11.446,0,0,1-11.432,11.432Z",
    transform: "translate(551 302.802)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 807.138,
    height: 455.431,
    transform: "translate(571.266 343.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(713.544 428.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1631-2611",
    "data-name": "Path 1631",
    d: "M329.256,249.686l-86.542-64.821L157.355,248.8l-1.955-2.606,87.314-65.4,86.131,64.513,85.589-93.664.344-.14,86.337-34.785,1.218,3.022L416.34,154.387Z",
    transform: "translate(-67.207 -107.955)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625-2612",
    "data-name": "Path 1625",
    d: "M841.882,590.59H321.361a1.629,1.629,0,0,1-1.629-1.629V339.476a1.629,1.629,0,0,1,3.258,0V587.332H841.882a1.629,1.629,0,1,1,0,3.258Z",
    transform: "translate(-319.732 -328.874)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626-2613",
    "data-name": "Path 1626",
    d: "M409.151,510.934H361.807a4.841,4.841,0,0,1-4.836-4.835V440.835A4.841,4.841,0,0,1,361.807,436h47.343a4.841,4.841,0,0,1,4.836,4.835V506.1A4.841,4.841,0,0,1,409.151,510.934Z",
    transform: "translate(-296.308 -267.137)",
    fill: "#3485ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627-2614",
    "data-name": "Path 1627",
    d: "M462.151,534.835H414.807A4.841,4.841,0,0,1,409.971,530V402.835A4.841,4.841,0,0,1,414.807,398h47.343a4.841,4.841,0,0,1,4.836,4.835V530a4.841,4.841,0,0,1-4.836,4.835Z",
    transform: "translate(-262.971 -291.039)",
    fill: "#3485ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628-2615",
    "data-name": "Path 1628",
    d: "M515.151,510.934H467.807a4.841,4.841,0,0,1-4.836-4.835V440.835A4.841,4.841,0,0,1,467.807,436h47.343a4.841,4.841,0,0,1,4.836,4.835V506.1A4.841,4.841,0,0,1,515.151,510.934Z",
    transform: "translate(-229.635 -267.137)",
    fill: "#3485ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629-2616",
    "data-name": "Path 1629",
    d: "M568.151,544.271H520.807a4.735,4.735,0,0,1-4.836-4.616V387.617A4.735,4.735,0,0,1,520.807,383h47.343a4.735,4.735,0,0,1,4.836,4.616V539.654A4.735,4.735,0,0,1,568.151,544.271Z",
    transform: "translate(-196.299 -300.474)",
    fill: "#3485ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630-2617",
    "data-name": "Path 1630",
    d: "M621.151,561.253H573.807a4.841,4.841,0,0,1-4.836-4.835V360.835A4.841,4.841,0,0,1,573.807,356h47.343a4.841,4.841,0,0,1,4.836,4.835V556.418a4.841,4.841,0,0,1-4.836,4.835Z",
    transform: "translate(-162.962 -317.456)",
    fill: "#3485ba"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 10.007,
    cy: 9.381,
    rx: 10.007,
    ry: 9.381,
    transform: "translate(78.959 130.086)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 10.007,
    cy: 10.007,
    r: 10.007,
    transform: "translate(165.266 66.294)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 10.007,
    cy: 9.381,
    rx: 10.007,
    ry: 9.381,
    transform: "translate(251.573 130.086)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_339",
    "data-name": "Ellipse 339",
    cx: 10.007,
    cy: 10.007,
    r: 10.007,
    transform: "translate(337.88 35.023)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 10.007,
    cy: 10.009,
    rx: 10.007,
    ry: 10.009,
    transform: "translate(424.187 0)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(1147.675 486.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1647-2618",
    "data-name": "Path 1647",
    d: "M852.789,302.971s-14.822-2.556-36.8-22.489c-17.389-15.766-40.844-12.666-49.888-10.678a1.544,1.544,0,0,0-.411,2.867c3.655,2,9.322,4.922,11.978,5.255,0,0-5.478,5.667.344,8.7a4.189,4.189,0,0,0,4.378-.422c2.8-2.044,10.578,2.6,21.855,5.011,0,0,43.955,45.488,54.177,37.777Z",
    transform: "translate(-764.883 -177.174)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648-2619",
    "data-name": "Path 1648",
    d: "M912.11,246.027s4.089,17.377,0,29.644l18.4,2.555,16.355-8.178V259.316s-7.667-16.355-5.622-35.266Z",
    transform: "translate(-748.527 -182.073)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649-2620",
    "data-name": "Path 1649",
    d: "M959,585.888s13.333,26.066,11.244,43.444,17.377,2.044,15.333-8.178c-.433,12.374,5.722-43.333,8.6-56.377a5.822,5.822,0,0,0-3.866-6.789c-6.145-2.022-16.433-4.5-21.6-.711C961.078,562.888,959,585.888,959,585.888Z",
    transform: "translate(-743.318 -145.273)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650-2621",
    "data-name": "Path 1650",
    d: "M916.154,608.743s-17.378,22.488-21.977,23-7.667,7.667,0,9.2a85.931,85.931,0,0,0,45.555-4.444,6.956,6.956,0,0,0,4.367-7.4l-2.933-21.889Z",
    transform: "translate(-751.037 -139.507)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651-2622",
    "data-name": "Path 1651",
    d: "M889.417,393.78,872.75,396a243.914,243.914,0,0,1-.2,58.588v70s-.322,6.167,12.478,15.133a478.531,478.531,0,0,1,38.755,30L970.16,609.9s18.4-22.489,15.844-35.777c0,0-30.666-9.711-34.755-25.555-2.344-9.067-14.233-16.666-23.966-21.444A29.8,29.8,0,0,1,911.338,493.3a26.08,26.08,0,0,1,2.611-6.567c8.178-14.311,19.933-46.51,19.933-46.51l-22.488-42.866Z",
    transform: "translate(-752.923 -163.218)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653-2623",
    "data-name": "Path 1653",
    d: "M911.441,634s30.155,5.111,31.177,8.178,0-4.089,0-4.089S960,585.447,955.951,538.947s5.111-77.177,5.111-77.177,10.733-34.755,4.6-54.688-70.532-11.244-70.532-11.244,22.489,52.644,21.978,77.688c0,0,2.555,75.643,7.155,84.332C924.218,557.814,917.063,631.924,911.441,634Z",
    transform: "translate(-750.412 -163.198)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654-2624",
    "data-name": "Path 1654",
    d: "M917.544,255.79s3.067,18.889,33.733,10.733l-20.4,155.364s-59.288,2.044-58.777-5.111l12.222-94.032Z",
    transform: "translate(-752.972 -178.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657-2625",
    "data-name": "Path 1657",
    d: "M921.667,255.33a31.633,31.633,0,0,1-15.789,6.5,35.921,35.921,0,0,0-14.511,4.311c-5.255,2.944-11.111,7.222-12.889,12.433-3.578,10.222-26.066,27.088-36.288,23.511l3.578,30.666s29.133-1.533,34.244-12.778L871.334,429.4H879s4.089-29.644,7.155-35.777,9.2-39.866,9.711-48.044,8.178-55.2,14.822-63.332l10.989-23.766Z",
    transform: "translate(-756.294 -178.599)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658-2626",
    "data-name": "Path 1658",
    d: "M939.965,238.974c-.667-4.844.667-7.867,1.278-13.544L912.11,247.407s.7,2.967,1.233,7.311a27.779,27.779,0,0,0,4.444.356C927.9,255.074,935.176,247.174,939.965,238.974Z",
    transform: "translate(-748.527 -181.92)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 27.6,
    cy: 27.6,
    r: 27.6,
    transform: "translate(141.606 16.432)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660-2627",
    "data-name": "Path 1660",
    d: "M890.521,201.6a32.24,32.24,0,0,1,2.051-12.6,3.148,3.148,0,0,0,.533,4.1,20.183,20.183,0,0,1,6.4-11.342c-1.815.3-2.748,2.543-2.3,4.328a9.844,9.844,0,0,0,3.148,4.43c-.154-2.7,1.631-5.22,3.887-6.7a23.32,23.32,0,0,1,7.589-2.748,4.4,4.4,0,0,0-2.913,4.512,1.261,1.261,0,0,0,.379.872,1.446,1.446,0,0,0,.862.226,66.027,66.027,0,0,0,7.968-.174,83.565,83.565,0,0,1,9.814-.523c10.255.431,20.562,7.435,22.859,17.434a40.077,40.077,0,0,1,.749,7.363l.5,12.624a46.147,46.147,0,0,1-.451,11.034,23.382,23.382,0,0,1-12.009,15.875c-3.7-5.363-4.03-12.255-5.312-18.644a9.435,9.435,0,0,0-1.6-4.1,3.6,3.6,0,0,0-3.948-1.333c-1.385.554-1.979,2.666-.831,3.61-1.026,1.21-2.943.308-4.1-.769a22.028,22.028,0,0,1-6.389-11.414c-.461-2.195-.923-4.9-3.077-5.651a5.722,5.722,0,0,0-2.276-.154c-4.492.308-11.517,2.164-15.865.738C892.2,211.282,890.521,205.385,890.521,201.6Z",
    transform: "translate(-749.054 -181.07)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662-2628",
    "data-name": "Path 1662",
    d: "M842.109,297.42s-4.089,18.889,3.578,30.666l4.344-.356-2.367-30Z",
    transform: "translate(-756.424 -173.923)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664-2629",
    "data-name": "Path 1664",
    d: "M945.333,251,978.3,279.366S997.721,299.3,989.543,331.5c0,0-3.578,47.022-7.667,49.066,0,0-14.311,28.622-15.333,55.71,0,0-20.189-40.633-28.888-17.122S909.8,448.041,909.8,448.041l11.244-139.009S949.422,259.644,945.333,251Z",
    transform: "translate(-748.783 -179.08)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665-2630",
    "data-name": "Path 1665",
    d: "M957.573,358.931s8.178-5.622,21.466,9.711L946.329,427.93,935.34,411.341S958.6,365.575,957.573,358.931Z",
    transform: "translate(-745.946 -167.201)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667-2631",
    "data-name": "Path 1667",
    d: "M948.22,361.769s18.089,20.311,25.144,17.055l6.533-15.211L955.375,353.08Z",
    transform: "translate(-744.515 -167.739)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670-2632",
    "data-name": "Path 1670",
    d: "M950.827,304.78s1.022,36.8-3.067,50.6",
    transform: "translate(-744.566 -173.105)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671-2633",
    "data-name": "Path 1671",
    d: "M876,311.935s6.133-2.044,6.133-7.155",
    transform: "translate(-752.539 -173.105)",
    opacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.47b006112b27283538f5b9c44808218b.svg";
export { ForwardRef as ReactComponent };